import React, { Component } from 'react'
import { connect } from 'react-redux'
import ButtonWithoutLoader from 'UI/ButtonWithoutLoader'
import axios from 'axios'
import { ExcelUploadColumns } from 'Constants'

import * as FileSaver from "file-saver";
import * as XLSX from 'xlsx';
import { Workbook } from 'exceljs/dist/exceljs';
import classNames from "classnames";
import { path } from 'Constants'
import {updateExchangeRateDetails} from 'actions/userActions'

class UploadAdminExchangeRate extends Component {
  constructor(props) {
    super(props)
    this.state = {
      csvFile: '',
      columns: [],
      data: [],
      responseMsg: '',
      excelData: [],
      isSaveInProgress: false,
    }

  }  

  handleDownload(){
    this.setState({ isSaveInProgress : true}, this.downloadExchangeRateSampleFile)
  }

  downloadExchangeRateSampleFile() {
    axios.get(path + 'Exchange_Rates.xlsx', {
        responseType: 'blob', // Ensure that the response is in binary form (Blob)
    })
    .then((response) => {
        // Create a link element
        const link = document.createElement('a');
        
        // Create a URL for the Blob
        const url = window.URL.createObjectURL(new Blob([response.data]));
        
        // Set the download attribute with the filename
        link.href = url;
        link.setAttribute('download', 'Exchange_Rates.xlsx'); // Specify the name of the downloaded file
        
        // Append the link to the document and trigger the download
        document.body.appendChild(link);
        link.click();
        
        // Clean up
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.setState({ isSaveInProgress : false});
    })
    .catch((error) => {
        console.error('There was an error downloading the file', error);
    });
}

  handleChange(e) {    
    const files = e.target.files;
    if (files && files[0]) this.setState({ file: files[0], responseMsg: '', isError: 'No', isLoading: false, isSaveInProgress: false }, this.handleFile);
  }

  handleFile() {
    this.setState({ responseMsg: "" })
    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;

    reader.onload = (e) => {
      /* Parse data */
      const bstr = e.target.result;
      const wb = XLSX.read(bstr, { type: rABS ? 'binary' : 'array', bookVBA: true });
      /* Get first worksheet */
      const wsname = wb.SheetNames[1];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      const data = XLSX.utils.sheet_to_json(ws, { defval: "" });
      this.setState({ excelData: data })
    }
    reader.readAsBinaryString(this.state.file);
  }


  
  handleSubmit = (e) => {

    let rowData = this.state.excelData;

    if (rowData.length == 0) {
      this.setState({ responseMsg: 'No Records found', isError: 'Yes', isLoading: false, isSaveInProgress: false })
      return;
    }

    this.setState({ isLoading: true, isSaveInProgress: true })
    var excRateItemArr = [];
    rowData.forEach((item) => {
      var fromCurCD = '';
      var toCurCD = '';
      var exchangeDate = '';
      if (item['CapIQ Exchange Rate Identifier'].length > 0) {
        fromCurCD = item['CapIQ Exchange Rate Identifier'].substr(4, 3);
        toCurCD = item['CapIQ Exchange Rate Identifier'].substr(1, 3);
      }
      var keys = Object.keys(item);
      exchangeDate = keys[7] + '-' + new Date().getFullYear();
      var excRateItem = {
        CURRENCY_ID: null,
        CURRENCY_IDENTIFIER: item['CapIQ Exchange Rate Identifier'],
        FROM_CURRENCY_CD: fromCurCD,
        FROM_CURRENCY_NAME: item['From Currency'],
        TO_CURRENCY_CD: toCurCD,
        TO_CURRENCY_NAME: item['To Currency'],
        EXCHANGE_RATE: item['Rate'],
        EXCHANGE_DATE: exchangeDate,
        USER_ID: localStorage.getItem('loggedinUser'),
        RECORD_FLAG: 'B'
      }

      excRateItemArr.push(excRateItem);
    });

    this.props.updateExchangeRateDetails(excRateItemArr)
      .then((results) => {        
        if (results.status === 200) {   
          this.props.reloadGrid();       
          this.setState({ responseMsg: 'Record/s has been updated successfully', isError: 'No', isLoading: false, isSaveInProgress: false })
        }
      }).catch((error) => {
        this.setState({ responseMsg: this.props.content.error, isError: 'Yes', isLoading: false, isSaveInProgress: false })
      })
  }

  render() {
    return (
      <div style={{ padding: '30px' }}>
        <div>
          {(this.state.isSaveInProgress) ?
            <img style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto' }}
              src={path + `images/ajax-loader.gif`} alt="" />
            : null
          }
        </div>

        <div className="grid-x grid-padding-x">
          <div className="medium-12 popHeader">{this.props.exchangeMastcontent.uploadExcel}</div>
        </div>
        <br></br>
        <div className="grid-x grid-padding-x pt10">

          <div className="medium-4"><ButtonWithoutLoader
            type="button"
            formNoValidate
            content={this.props.content.downloadBtn}
            onClick={(e) => this.handleDownload(e)}
            color
          /></div>

          <div className="medium-5 pt10" style={{ float: 'right' }}>
            <input
              type="file"
              style={{ display: 'block' }}
              accept='.xlsx, .xls'
              id='csvFile'
              onChange={(e) => this.handleChange(e)}
            />
          </div>

          <div className="medium-3" style={{ float: 'left' }}>
            <ButtonWithoutLoader
              type="button"
              formNoValidate
              content={this.props.content.uploadBtn}
              color
              onClick={this.handleSubmit.bind(this)}
              className={classNames('float-right',
                {
                  'hand-cursor': this.state.isLoading ? false : true,
                  'gray-scale': this.state.isLoading ? true : false
                })}
              disabled={this.state.isLoading ? true : false}
            />
          </div>

        </div>

        <br></br>
        <div className="grid-x grid-padding-x" style={{ color: (this.state.isError === "Yes") ? 'red' : 'green' }}>{this.state.responseMsg}</div>
      </div>
    )
  }

}

const mapStateToProps = state => {
  return {
    userData: state.valueStory,
    user: state.default,
    validation: state.content.validation,
    spendDetails: state.spendDetails,
    content: state.content.spendAnalysis.detailedFile,
    exchangeMastcontent: state.content.exchange,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updateExchangeRateDetails: (records) => dispatch(updateExchangeRateDetails(records)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(UploadAdminExchangeRate)